//-- Copyright (c) 2021 TMT Insights Group, LLC
import { TitleConfig } from '@/__configs/config_types';
import { TitleEntity } from '@/redux/slices/slice_types';
import { getLineageMetaTitle } from '@tmt-insights/oms_fe_core/utils';

const titleConfig: TitleConfig = {
  metadata: {
    name: {
      label: '{{entity_type}} Name'
    },
    program_id: {
      label: 'Program ID'
    },
    lineage_meta__series_name: {
      label: 'Series Name'
    },
    lineage_meta__season_sequence_order: {
      label: 'Season Number'
    },
    sequence_order: {
      label: 'Episode Number'
    },
    alternate_name: {
      label: 'Alternate Name'
    },
    genres: {
      label: 'Genres',
      render: (value: any) => value?.join(', ')
    },
    release_year: {
      label: 'Release Year'
    },
    meta__usage: {
      label: 'Usage'
    },
    meta__program_sub_type: {
      label: 'Program Sub Type'
    }
  },
  shouldShowRelatedJobs: true,

  parseDataFn: (data) => ({
    ...data,
    entity_type: data.program_type as TitleEntity['entity_type'],
    og_entity_type: data.entity_type,
    display_title: data.lineage_meta?.series_name,
    name: `${data.lineage_meta?.series_name}: ${getLineageMetaTitle(data)}`
  })
};

export default titleConfig;
